import React, { useContext, useEffect, useRef, useState } from "react";
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, FormControl, FormControlLabel, FormGroup, IconButton, InputLabel, MenuItem, Select, TextField, Typography, Fab, DialogActions, Tabs, Tab, Autocomplete } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Tooltip from "@mui/material/Tooltip";
import { CloseOutlined } from "@mui/icons-material";
import { Stack } from "@mui/material";
import styled from "styled-components";
import moment from "moment";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
const isMobile = window.innerWidth < 900;
const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
`;
const TableContainer = styled.div`
  // height: calc(
  //   100vh - ${isMobile ? "106px - 20px - 82.23px" : "100px - 20px - 23.77px"}
  // );
  width: ${isMobile ? "100%" : "98%"};
  // border: solid 1px lightGrey;
  border-radius: 8px;
  margin-left:${isMobile ? "0px" : "10px"};
  margin-bottom:${isMobile ? "0px" : "10px"};
`;
const Input = styled.input`
  display: none;
`;
const ExpenseAddModal = ({ onClose, data = '', id = '', fetchExpense }) => {
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({});
  const [employee, setEmployee] = useState([])
  const [hasChange, setHasChange] = useState(false);
  const [details, setDetails] = useState({});
  const detailsRef = useRef();
  const [expenseTypes, setExpenseTypes] = useState()
  const [expenseSubTypes, setExpenseSubTypes] = useState([])
  const [expensePurpose, setExpensePurpose] = useState()
  const [selectedExpenseTypeId, setSelectedExpenseTypeId] = useState(null);
  const [expensePurposeLabel, setExpensePurposeLabel] = useState()
  const [expenseTypesLabel, setExpenseTypesLabel] = useState()
  const [allParty, setAllParty] = useState([])
  const [allPartyLabel, setAllPartyLabel] = useState([])
  const [partyType, setPartyType] = useState('1');
  const [distributorList, setDistributorList] = useState([]);
  const [distributorLabel, setDistributorLabel] = useState([]);
  const [employeeLabel, setEmployeeLabel] = useState([])
  const [selectedExpenseType, setSelectedExpenseType] = useState(null);
  const [uploadedFileName, setUploadedFileName] = useState("");

  // State for image preview
  const [imagePreview, setImagePreview] = useState(null);

  // File upload handler
  // const handleFileUpload = async (event) => {
  //   const file = event.target.files[0];
  //   if (!file) return;
  //   try {
  //     setLoading(true);
  //     // Simulate upload: replace with your actual upload logic
  //     // Example: let response = await window.Platform.database.uploadFile(file);
  //     // let fileName = response.fileName;
  //     // For now, just use file.name as placeholder
  //     const fileName = file.name;
  //     // For preview, create a local URL
  //     const localUrl = URL.createObjectURL(file);
  //     detailUpdate("billLink", `uploads/${fileName}`);
  //     setImagePreview(localUrl);
  //     setLoading(false);
  //   } catch (e) {
  //     setLoading(false);
  //     window.NotificationUtils.showError("File upload failed");
  //   }
  // };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("files", file); // must match multer field name "files"
      // const response = await axios.post("http://localhost:5000/uploadMultipleImages", formData,{
      // const response = await axios.post("http://localhost:5000/uploadMultipleImages", formData,{

      let response = await window.Platform.database.uploadMultipleImages(formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
      );

      if (response.data.files && response.data.files.length > 0) {
        const uploadedFile = response.data.files[0];
        setUploadedFileName(uploadedFile.fileName);

        // For preview, local URL
        const localUrl = URL.createObjectURL(file);
        setImagePreview(localUrl);

        // update details state
        detailUpdate("billLink", "uploads/" + uploadedFile.fileName);
      }

      setLoading(false);
    } catch (error) {
      console.error("Upload failed", error);
      setLoading(false);
      window.NotificationUtils.showError("File upload failed");
    }
  };


  // Remove uploaded image
  const handleRemoveImage = () => {
    detailUpdate("billLink", "");
    setImagePreview(null);
  };

  const createExpense = async () => {
    console.log(details, "payload detailsasasasasas");
    // return;
    try {
      const errors = validateForm(details);
      setErrors(errors);
      console.log(Object.keys(errors).length, "Object.keys(errors).length")
      if (Object.keys(errors).length === 0) {
        console.log("aaayayyaaayayayyya")
        let results = await window.Platform.database.createExpense(details)
        window.NotificationUtils.showSuccess("Expense created successfully")
        onClose();
        fetchExpense();
      } else {
        window.NotificationUtils.showError("Please fill all required fields.")
      }
    } catch (error) {
    }
  }
  console.log(errors)
  // const handleFileUpload = async (event) => {
  //   const file = event.target.files[0];
  //   if (!file) return;
  //   try {
  //     setLoading(true);
  //     // Simulate upload: replace with your actual upload logic
  //     // Example: let response = await window.Platform.database.uploadFile(file);
  //     // let fileName = response.fileName;
  //     // For now, just use file.name as placeholder
  //     const fileName = file.name;
  //     detailUpdate("billLink", `uploads/${fileName}`);
  //     setLoading(false);
  //   } catch (e) {
  //     setLoading(false);
  //     window.NotificationUtils.showError("File upload failed");
  //   }
  // };

  const getUsersFieldRole = async () => {
    try {
      setLoading(true);
      let results = await window.Platform.database.getUsersForWork();
      setEmployee(results.data);
      setEmployeeLabel(results.data.map((data) => data.id))
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Error Fetching Data");
    }
    finally {
      setLoading(false)
    }
  }
  const formatDate = (data) => {
    const timestamp = new Date(data.$d);
    const datePickerResponse = new Date(data.$d);
    const year = datePickerResponse.getFullYear();
    const month = String(datePickerResponse.getMonth() + 1).padStart(2, '0');
    const day = String(datePickerResponse.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    const unixTimestamp = Math.floor(timestamp.getTime() / 1000);
    detailUpdate("date", moment.unix(unixTimestamp).format('YYYY-MM-DD'))
  }

  const getExpenseType = async () => {
    try {
      setLoading(true);
      let results = await window.Platform.database.getExpenseType();
      setExpenseTypes(results.data);
      setExpenseTypesLabel(results.data.map((data) => data.expenseTypeId))
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Error Fetching Data");
    }
    finally {
      setLoading(false)
    }
  }

  const getExpenseSubType = async () => {
    try {
      setLoading(true);
      let results = await window.Platform.database.getExpenseSubType();
      setExpenseSubTypes(results?.data);
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Error Fetching Data");
    }
    finally {
      setLoading(false)
    }
  }

  const filteredSubTypes = expenseSubTypes.filter(
    (sub) => sub.expenseTypeId === selectedExpenseTypeId
  );

  const getExpensePurpose = async () => {
    try {
      setLoading(true);
      let results = await window.Platform.database.getExpensePurpose();
      setExpensePurpose(results.data);
      setExpensePurposeLabel(results.data.map((data) => data.expensePurposeId))
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Error Fetching Data");
    }
    finally {
      setLoading(false)
    }
  }

  const getallparty = async (data) => {
    try {
      setLoading(true);
      if (partyType === '1') {
        let results = await window.Platform.database.getAllSchool(data);
        setAllParty(results.data);
        setAllPartyLabel(results.data.map((data) => data.schoolId));
      } else {
        let results = await window.Platform.database.getAllDistri(data);
        setDistributorList(results.data);
        setDistributorLabel(results.data.map((data) => data.distributorID));
      }
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Error Fetching Data");
    }
    finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getUsersFieldRole()
    getExpensePurpose()
    getExpenseType()
    getExpenseSubType()
  }, [])

  useEffect(() => {
    if (details.employeeId) {
      setAllParty([]);
      setAllPartyLabel([]);
      setDistributorList([]);
      setDistributorLabel([]);
      const payload = { ownerId: details.employeeId };
      getallparty(payload);
    }
  }, [partyType, details.employeeId]);


  const detailUpdate = (key, value) => {
    if (!hasChange) {
      setHasChange(!hasChange);
    }
    var newDetails = { ...details };
    newDetails[key] = value;
    if (key === 'employeeId') {
      const payload = {
        ownerId: value
      }
      getallparty(payload)
    }
    if (key === 'type') {
      // Reset party selection and fetch new list
      setDetails({ ...newDetails, partyId: '' });
      if (details.employeeId) {
        const payload = { ownerId: details.employeeId };
        getallparty(payload);
      }
    }
    setDetails(newDetails);
  };

  const renderContent1 = () => {
    return (
      <div style={{ overflowY: "auto" }}>
        <Stack direction={"row"} spacing={2} padding={1}>
          <Autocomplete
            options={employeeLabel}
            disabled={data?.status === 0}
            getOptionLabel={(option) => {
              let manager = employee?.find(
                (member) => member?.id === option
              );
              return `${manager?.name} - ${manager?.username}`;
            }}
            style={{ width: "100%" }}
            onChange={(event, selectedOption) => {
              detailUpdate("employeeId", selectedOption);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Employee"
                required
                variant="outlined"
                error={errors.employeeId ? true : false}
              />
            )}
          />
        </Stack>
        <Stack direction={"row"} spacing={2} padding={1}>
          <Autocomplete
            options={expenseTypesLabel}
            disabled={data?.status === 0}
            getOptionLabel={(option) => {
              let manager = expenseTypes?.find(
                (member) => member?.expenseTypeId === option
              );
              return `${manager?.expenseTypeName}`;
            }}
            style={{ width: "100%" }}
            onChange={(event, selectedOption) => {
              let manager = expenseTypes.find(
                (member) => member.expenseTypeId === selectedOption
              );
              setSelectedExpenseTypeId(manager?.expenseTypeId || null);
              setSelectedExpenseType(manager || null);
              // Set expenseType first, then clear subType and typeRemark
              setDetails(prev => ({
                ...prev,
                expenseType: manager?.expenseTypeId || '',
                expenseSubType: '',
                typeRemark: ''
              }));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Expense Type"
                required
                variant="outlined"
                error={errors.expenseType ? true : false}
              />
            )}
          />
          {selectedExpenseType?.subTypeRequired === 1 && (
            <FormControl fullWidth>
              <InputLabel
                id="select-Expense-sub-type"
                required
                error={errors.expenseSubType ? true : false}
              >
                Select Expense Sub Type
              </InputLabel>
              <Select
                labelId="select-Expense-sub-type"
                id="select-Expense-sub-type"
                onChange={(e) => detailUpdate("expenseSubType", e.target.value)}
                label="Select Expense Sub Type"
                required
                error={errors.expenseSubType ? true : false}
              >
                {filteredSubTypes.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          {selectedExpenseType?.textBox === 1 && (
            <TextField
              label="Expense Type Description"
              variant="outlined"
              fullWidth
              required
              error={errors.typeRemark ? true : false}
              onChange={(e) =>
                detailUpdate("typeRemark", e.target.value)
              }
            />
          )}
        </Stack>
        <Stack direction={"row"} spacing={2} padding={1}>
          <Autocomplete
            options={expensePurposeLabel}
            disabled={data.status === 0}
            getOptionLabel={(option) => {
              let manager = expensePurpose.find(
                (member) => member.expensePurposeId === option
              );
              return `${manager?.expensePurposeName}`;
            }}
            style={{ width: "100%" }}
            onChange={(event, selectedOption) => {
              let manager = expensePurpose.find(
                (member) => member.expensePurposeId === selectedOption
              );
              detailUpdate("expensePurpose", manager?.expensePurposeId);
            }
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Expense Purpose"
                required
                variant="outlined"
                error={errors.expensePurpose ? true : false}
              />
            )}
          />   </Stack>

        <Stack direction={"row"} spacing={2} padding={1}>
          <TextField label="Amount" required value={details.amount || ""} type="text" fullWidth onChange={(e) => detailUpdate("amount", e.target.value)} error={errors.amount ? true : false} />
        </Stack>
        <Stack direction={"row"} spacing={2} padding={1}>
          <FormControl fullWidth>
            <InputLabel id="party-type-label">Select Party Type</InputLabel>
            <Select
              labelId="party-type-label"
              id="party-type-select"
              value={partyType}
              label="Select Party Type"
              onChange={e => {
                setPartyType(e.target.value);
                detailUpdate('type', e.target.value);
              }}
            >
              <MenuItem value="1">School</MenuItem>
              <MenuItem value="0">Distributor</MenuItem>
            </Select>
          </FormControl>
          {partyType === '1' ? (
            <Autocomplete
              required
              options={allPartyLabel}
              disabled={data.status === 0}
              getOptionLabel={(option) => {
                let manager = allParty.find(
                  (member) => member.schoolId === option
                );
                return `${manager?.schoolName}`;
              }}
              style={{ width: "100%" }}
              onChange={(event, selectedOption) => {
                detailUpdate("partyId", selectedOption);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select School"
                  required
                  variant="outlined"
                  error={errors.partyId ? true : false}
                />
              )}
            />
          ) : (
            <Autocomplete
              required
              options={distributorLabel}
              disabled={data.status === 0}
              getOptionLabel={(option) => {
                let manager = distributorList.find(
                  (member) => member.distributorID === option
                );
                return `${manager?.DistributorName}`;
              }}
              style={{ width: "100%" }}
              onChange={(event, selectedOption) => {
                detailUpdate("partyId", selectedOption);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Distributor"
                  required
                  variant="outlined"
                  error={errors.partyId ? true : false}
                />
              )}
            />
          )}
        </Stack>
        <Stack direction={"row"} spacing={2} padding={1}>
          <TextField label="Enter Remark" type="text" fullWidth onChange={(e) => detailUpdate("remark", e.target.value)} required error={errors.remark ? true : false} />
        </Stack>
        <Stack direction="row" spacing={2} padding={1}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker label="Choose Date"
              disableFuture={true}
              sx={{ width: "40%" }} disabled={loading} format="YYYY/MM/DD" onChange={(data) => formatDate(data)} />
          </LocalizationProvider>

          {/* <Button
            variant="outlined"
            component="label"
            startIcon={<CloudUploadIcon />}
            disabled={loading}
          >
            Upload Bill Image
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={handleFileUpload}
            />
          </Button>
          {details.billLink && (
            <Box sx={{ ml: 2, display: 'flex', alignItems: 'center' }}>
              <Typography variant="body2" color="primary">
                Uploaded: {details.billLink}
              </Typography>
            </Box>
          )} */}
          <Button
            variant="outlined"
            component="label"
            startIcon={<CloudUploadIcon />}
            disabled={loading}
          >
            Upload Bill Image
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={handleFileUpload}
            />
          </Button>
          {imagePreview && (
            <Box mt={2}>
              <img src={imagePreview} alt="Preview" width={150} />
            </Box>
          )}
        </Stack>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '10px' }}>
          {/* <Button variant="contained" onClick={() => onsubmit(form)} > */}
          <Button variant="contained" onClick={() => createExpense()} >
            Create
          </Button>
          <br />
        </div>
      </div>
    )
  }
  //  
  const validateForm = (data) => {
    console.log(data, "aasdasdads", selectedExpenseType?.subTypeRequired, ",,,,", selectedExpenseType?.textBox)
    const errors = {};
    if (!data.employeeId?.trim()) {
      errors.employeeId = "Employee is required";
    }
    if (!data.expenseType?.trim()) {
      errors.expenseType = "Expense type is required";
    }
    // if (selectedExpenseType?.subTypeRequired === 1) {
    //   if (!data?.expenseSubType?.trim()) {
    //     errors.expenseSubType = "Expense Sub Type Is Required"
    //   }
    // }
    if (selectedExpenseType?.subTypeRequired === 1) {
      if (
        details.expenseSubType === undefined ||
        details.expenseSubType === null ||
        details.expenseSubType === "" ||
        (typeof details.expenseSubType === "string" && details.expenseSubType.trim() === "")
      ) {
        errors.expenseSubType = "Expense Sub Type Is Required";
      }
    }
    if (selectedExpenseType?.textBox === 1) {
      if (!data?.typeRemark?.trim()) {
        errors.typeRemark = "Expense Type Description Is Required"
      }
    }
    if (!data.expensePurpose?.trim()) {
      errors.expensePurpose = "Expense purpose is required";
    }
    if (!data.amount?.trim()) {
      errors.amount = "Amount is required";
    }
    if (!data.partyId?.trim()) {
      errors.partyId = "Party is required";
    }
    if (!data.remark?.trim()) {
      errors.remark = "Remark is required";
    }
    return errors;
  };

  const onsubmit = async (data) => {
    try {
      await createExpense()
    }
    catch (error) {
      console.log(error)
      setLoading(false)

    }
  }

  return (
    <Dialog disableEnforceFocus maxWidth="md" fullWidth={true} open={true} >
      {loading && <OpaqueLoading />}
      <ModalHeaderContainer style={{ marginBottom: 2, paddingBottom: 3 }}>
        <Typography variant={isMobile ? "h6" : "h5"}>
          Add Expense
          <Tooltip title="Order Id">
            {id}
          </Tooltip>
        </Typography>
        <IconButton onClick={onClose} >
          <CloseOutlined />
        </IconButton>
      </ModalHeaderContainer>
      <TableContainer>
        {renderContent1()}
      </TableContainer>
    </Dialog>
  );
};
export default ExpenseAddModal;